import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getPermissionItemFailed,
  getPermissionItemStart,
  getPermissionItemSuccess,
} from "../redux/roleItem";
import { permissionItemSelector } from "../redux/selector";
import { getPermissionItemApi } from "core/http/service/accountInfo";

function* getPermissionItemWork(action) {
  const screenCode = action.payload;
  const data = yield select(permissionItemSelector);

  try {
    if (!screenCode) return;
    if (!data[screenCode]!) {
      const response = yield call(getPermissionItemApi, screenCode);

      yield put({
        type: getPermissionItemSuccess.type,
        payload: { [screenCode]: response },
      });
    } else {
      yield put({
        type: getPermissionItemSuccess.type,
        payload: {},
      });
    }
  } catch (error: any) {
    yield put({
      type: getPermissionItemFailed.type,
    });
  }
}

function* watchGetPermissionItem() {
  yield takeLatest(getPermissionItemStart.type, getPermissionItemWork);
}

export default function* getPermissionItemSaga() {
  yield all([watchGetPermissionItem()]);
}
